import { render, staticRenderFns } from "./machines.vue?vue&type=template&id=60c5406a&"
import script from "./machines.vue?vue&type=script&lang=js&"
export * from "./machines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports